var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","line-height":"calc(100vh - 200px)"}},[_c('h1',[_vm._v("程序员已祭天")])])}]

export { render, staticRenderFns }